<template>
  <v-dialog
    v-model="openModalComputed"
    @click:outside="handleClose"
    :fullscreen="isMobileBreakpoint"
    :max-width="checkoutAi ? '1020' : '800'"
    class="ma-0"
  >
    <v-card
      class="d-flex flex-column justify-space-between align-center pa-6"
      flat
      tile
      height="637"
      v-if="!checkoutAi && !generatedAiWorkFlow"
    >
      <div class="w-full d-flex justify-end">
        <v-btn icon @click="handleClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="container-title mb-8">
        <img
          width="66px"
          height="40px"
          :src="require('@/assets/panda-brand-ia.png')"
        />
        <h1 class="body-bold-xlarge mt-2">
          {{ $t('message.ai.aiWorkFlowChargeModal.title') }}
        </h1>
        <span class="body-regular-base neutral-40-light--text text-center">
          {{ $t('message.ai.aiWorkFlowChargeModal.autoGenerationFeatures') }}
        </span>
        <span class="body-regular-base neutral-40-light--text text-center">
          {{ $t('message.ai.aiWorkFlowChargeModal.creditCostPerMinute') }}
        </span>
        <base-btn type="primary" class="mt-4" @click="startBuy">
          {{ $t('message.ai.aiWorkFlowChargeModal.startButton') }}</base-btn
        >
      </div>
      <div>
        <span class="body-regular-small neutral-40-light--text"
          >{{ $t('message.ai.aiWorkFlowChargeModal.billingRulesInfo')
          }}<a
            target="_blank"
            type="secondary"
            size="xsmall"
            :href="$t('message.ai.aiWorkFlowChargeModal.billingRulesInfoHref')"
          >
            {{ $t('message.embedModal.knowMore') }}

            <v-icon size="12">mdi-open-in-new</v-icon>
          </a></span
        >
      </div>
    </v-card>
    <CheckoutAiTemplate
      v-else-if="!generatedAiWorkFlow"
      type="AiWorkFlow"
      :remainingCredits="remainingCredits"
      :totalPrice="aiWorkFlowPrice"
      :videos="[video]"
      :hasNoEnoughCredits="hasNoEnoughCredits"
    />
    <GenerateAiTemplate type="AiWorkFlow" v-if="generatedAiWorkFlow" />
  </v-dialog>
</template>

<script>
import linkHelper from '@/utils/linkHelper.mixin.js'
import CheckoutAiTemplate from '@/components/CheckoutAiTemplate.vue'
import GenerateAiTemplate from '@/components/GenerateAiTemplate.vue'
import { mapState } from 'vuex'
export default {
  name: 'AiWorkFlowChargeModal',
  mixins: [linkHelper],
  components: {
    CheckoutAiTemplate,
    GenerateAiTemplate,
  },

  props: {
    openModal: {
      type: Boolean,
      required: true,
    },
    aiWorkFlowCreditsBalance: {
      type: Object,
      required: true,
    },
    aiWorkFlowCreated: {
      type: Boolean,
      required: true,
    },
    video: {
      type: Object,
    },
  },
  data: () => ({
    open: false,
    aiWorkFlowPrice: 0,
    creditsBalance: 0,
    remainingCredits: 0,
    isLoading: false,
    hasNoEnoughCredits: false,
    checkoutAi: false,
    generatedAiWorkFlow: false,
  }),
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    logoConfig() {
      return {
        top: -73,
        left: 295,
        size: 0.5,
        rotation: 0,
      }
    },
    openModalComputed() {
      return this.openModal || this.open
    },
    arrowConfig() {
      return {
        top: -35,
        left: 100,
        size: 0.65,
        rotation: 100,
      }
    },
    checkoutAiComputed() {
      return this.checkoutAi
    },
    textConfig() {
      return {
        text: this.$i18next.t('message.ai.aiWorkFlowChargeModal.emptyState'),
        top: 85,
        left: 235,
        size: '1em',
        rotation: 0,
        textAlign: 'center',
        textWidth: '40%',
        hrefText: this.$i18next.t(
          'message.ai.aiWorkFlowChargeModal.addCredits'
        ),
        onClick: this.handleGoChargeCredits,
      }
    },
    hasEnoughCredits() {
      return !(this.remainingCredits < 0)
    },
  },
  watch: {
    aiWorkFlowCreditsBalance: {
      handler(balance) {
        this.aiWorkFlowPrice = balance.aiWorkFlowPrice
        this.creditsBalance = balance.creditsBalance
        this.remainingCredits = balance.remainingCredits
        if (this.remainingCredits < 0) {
          this.hasNoEnoughCredits = true
        }
      },
      deep: true,
    },
    openModal: function (val) {
      if (val) {
        this.checkoutAi = false
        this.generatedAiWorkFlow = false
      }
    },
    aiWorkFlowCreated: function (val) {
      if (val) {
        this.isLoading = !val
        this.generatedAiWorkFlow = true
      }
    },
  },
  methods: {
    startBuy() {
      this.checkoutAi = true
    },
    handleKnowMore() {
      const link = this.getAiHelperLink()
      window.open(link, '_blank')
    },
    handleClose() {
      this.$root.$emit('closeAiWorkFlowModal')
    },
    generateAiWorkFlow() {
      this.$root.$emit('generateAiWorkFlow')
      this.isLoading = true
    },
    handleGoChargeCredits() {
      this.handleClose()
      return this.$router.push({ name: 'Credits', query: { charge: 'true' } })
    },
  },
  mounted() {
    this.$root.$on('backAiWorkFlowModal', () => {
      this.checkoutAi = false
    })
    this.$root.$on('backFromPaymentAiWorkFlowModal', () => {
      this.open = true
      this.$nextTick(() => {
        this.startBuy()
      })
    })
  },
}
</script>
<style lang="scss" scoped>
.container__credit-spend {
  width: 400px;
  position: relative;
  left: 0;
  margin: auto;
}

.v-toolbar__items > .v-btn {
  border-radius: 0;
  height: 50% !important;
  max-height: none;
  margin-top: 17px;
}
.text-bold {
  font-weight: 500;
  font-size: 16px;
}

.custom-border {
  border: 1px solid var(--v-neutral-lighten3);
}

.mdi-icon {
  justify-content: flex-end !important;
}
.bg-color {
  background-color: var(--v-newBackground-base) !important;
}
.card-height {
  height: auto !important;
}
.hide-card {
  visibility: hidden;
}
.container-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}
</style>

<style lang="scss">
.bg-color-icon {
  .v-image__image {
    background-color: var(--v-newBackground-base) !important;
  }
}
.w-full {
  width: 100%;
}
</style>
